module.exports = __webpack_public_path__ + "media/icons/icon-bar-c89a6345.png";